import { Component, OnInit, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { WatermarkUniversalConfigComponent } from '../watermark-universal-config/watermark-universal-config.component';
import { takeUntil } from 'rxjs/operators';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { NgControl } from '@angular/forms';
import {translationProvider} from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'app-watermark-universal-inline-picker',
    templateUrl: './watermark-universal-inline-picker.component.html',
    styleUrls: ['./watermark-universal-inline-picker.component.scss'],
    providers: [translationProvider('publicSessionEditor')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WatermarkUniversalInlinePickerComponent
  extends AbstractValueAccessor
  implements OnInit {
  constructor(
    private dialog: ZalamoDialogService,
    @Self() @Optional() public ngControl: NgControl
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {}

  openOptions() {
    const ref = this.dialog.openRight(WatermarkUniversalConfigComponent);
    ref.componentInstance.model.patchValue(this.value);
    ref.componentInstance.saved
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe((saved) => {
        this.writeValue(saved);
        ref.close();
      });
  }
}
